"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeIndex = void 0;
/**
 * Age index. The more recent, the lower the value
 */
class AgeIndex {
    static get(node) {
        let monthDifference = AgeIndex.monthDifference(node.dateDiscovered, new Date());
        if (monthDifference > 6) //older then 6 months
            return 1;
        else
            return monthDifference / 6;
    }
    static monthDifference(date1, date2) {
        let months;
        months = (date2.getFullYear() - date1.getFullYear()) * 12;
        months -= date1.getMonth() + 1;
        months += date2.getMonth();
        return months <= 0 ? 0 : months;
    }
}
exports.AgeIndex = AgeIndex;
//# sourceMappingURL=age-index.js.map